import { formatDate } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Pipe({
    name: 'datePipe',
})
export class DatePipe implements PipeTransform {

    constructor(
        private myTranslateService: TranslateService,
    ) {
    }

    public transform(value: any, locale?: string, format?: string, timezone?: string, utc?: boolean): string | null {
        if (value == null) {
            return '';
        }
        let _format: string = format || this.myTranslateService.instant('sla-core.date.pattern');
        let _locale: string = locale || this.myTranslateService.instant('sla-core.commons.locale');
        let _timezone: string = timezone || this.myTranslateService.instant('sla-core.commons.timezone');
        if (utc) {
            _timezone = 'UTC';
        }
        if (_format === 'sla-core.date.pattern') {
            _format = null;
        }
        if (_locale === 'sla-core.commons.locale') {
            _locale = null;
        }
        if (_timezone === 'sla-core.commons.timezone') {
            _timezone = null;
        }
        const _value: any = value;
        if ((_locale === 'th-TH' || _locale.startsWith('th')) && value) {
            const dateString: string = formatDate(_value, _format, _locale, _timezone);
            const year: string = (Number(formatDate(_value, 'yyyy', _locale, _timezone)) + 543).toString();

            const index: number = _format.indexOf('y');
            const lastIndex: number = _format.lastIndexOf('y') + 1;
            if (index !== -1) {
                const partOne: string = dateString.substring(0, index);
                const partTwo: string = dateString.substring(lastIndex);
                return partOne + year.slice(index - lastIndex) + partTwo;

            } else {
                return dateString;
            }
        }

        if (_locale.endsWith('Dummy')) {
            _locale = _locale.split('-')[ 0 ];
        }
        return formatDate(_value, _format, _locale, _timezone);
    }
}
